




























import { Vue, Component } from 'vue-property-decorator'

const AppProps = Vue.extend({
  props: {
  }
})

@Component({})
export default class Contact extends AppProps {
  kontaktpersoner = [
    {
      id: 0,
      name: 'Jeppe Nørregaard',
      email: 'jeppenuuk@gmail.com',
      phone: '+45 5382 1111'
    },
    {
      id: 1,
      name: 'Mathias Geisler',
      email: 'geisleren@gmail.com',
      phone: '+45 6013 1579'
    },
    {
      id: 2,
      name: 'Henriette Steenhoff (hjemmeside)',
      email: 'henriette.steenhoff@gmail.com',
      phone: '+45 2666 1248'
    }
  ]
}
